export enum WebsocketChannel {
  PushFeed = 'push-feed',
}
